import Backbone from 'backbone';

import AssessmentDetailsView from '../views/AssessmentDetailsView';
import GetAssessmentAttachments from '../services/GetAssessmentAttachments';

export default async function loadAssessmentDetailsView(assessmentDetails) {
  const attachments = await GetAssessmentAttachments(assessmentDetails.assessmentId);

  return new AssessmentDetailsView({
    model: new Backbone.Model({
      assessmentDetails,
      attachments
    })
  });
}
